module.exports = __webpack_public_path__ + "1ebc4d442d4eab0979e47e7f5a896869.svg";